//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '../i18n'
//import axios from 'axios'
import { settings } from '../settings';

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: settings.default_locale, // set locale
    fallbackLocale: settings.default_locale,
    messages: messages // set locale messages
})

export function setI18nLanguage(lang) {
    i18n.locale = lang
    //axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}